import * as types from './mutation-types'

const namespaced = true

const initialState = {
    list: []
}

const mutations = {
    [types.PUT_ELECTIONS](state, elections) {
        state.list = elections
    }
}

const actions = {
    async set({ commit }) {
        await fetch("https://forecasting-data.decisiondeskhq.com/2020/prod/elections.json")
            .then(response => response.json())
            .then(data => {
                commit(types.PUT_ELECTIONS, data);
            })
            .catch(error => console.error(error));
    }
}

const getters = {
    list(state) {
        return state.list
    }
}

export default {
    namespaced,
    state: initialState,
    mutations,
    actions,
    getters
}
